import {propertyFormat} from '../lib/propertyFormat';
import _cloneDeep from 'lodash/cloneDeep';

export const searchResults = (state) => {
  let returnVar = state;
  if (state.status == 'success' && state.results.content.length) {
    let searchProperties = _cloneDeep(state);
    for (var i = 0; i < searchProperties.results.content.length; i++) {
      propertyFormat(searchProperties.results.content[i]);
    }
    returnVar = searchProperties;
  }
  return returnVar;
};

export const searchPropertiesFallbackResults = (state) => {
  let returnVar = state;
  if (state && state.results && state.results.content) {
    let searchPropertiesFallback = _cloneDeep(state);
    searchPropertiesFallback.results.content.forEach(property => propertyFormat(property));
    returnVar = searchPropertiesFallback;
  }
  return returnVar;
};

export const searchResultsMarker = (state) => {
  let list = [];
  if (state.searchPropertiesMap.results && state.searchPropertiesMap.results.content) {
    list = state.searchPropertiesMap.results.content;
  }
  return list;
};
